import { makeAutoObservable, runInAction } from 'mobx';
import {
  ElectricBoxDetails,
  IElectricBox,
  IElectricBoxParams,
} from 'src/@types/Choqorak/Settings/ElectricBox';
import agent from 'src/api/agent';
export default class ElectricBoxStore {
  openDialog = false;

  ElectricBoxRegistry = new Map<number, IElectricBox>();

  editMode = false; //When click on edit button

  selectedElectricBox: IElectricBox | undefined = undefined;

  totalRecord: number = 0;

  selectedElectricBoxDetail: ElectricBoxDetails | undefined;

  ID: any = localStorage.getItem('id');

  constructor() {
    makeAutoObservable(this);
  }

  get ElectricBoxList() {
    return Array.from(this.ElectricBoxRegistry.values());
  }

  setElectricBoxList = (ElectricBox: IElectricBox) => {
    this.ElectricBoxRegistry.set(ElectricBox.electricBoxId!, ElectricBox);
  };

  //Pagination
  loadElectricBox = async (params: IElectricBoxParams) => {
    // this.ElectricBoxRegistry.clear();
    try {
      const result = await agent.ElectricBox.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setElectricBoxList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  ElectricBoxSearch = async (params: IElectricBoxParams) => {
    this.ElectricBoxRegistry.clear();
    this.loadElectricBox(params);
  };

  getElectricBoxFromRegistry = (id: number) => {
    let ElectricBox = this.ElectricBoxRegistry.get(id);
    if (ElectricBox) {
      this.editMode = true;
      this.selectedElectricBox = ElectricBox;
    }
  };

  clearSelectedElectricBox = () => {
    this.editMode = false;
    this.selectedElectricBox = undefined;
    this.selectedElectricBoxDetail = undefined;
  };

  deleteElectricBox = async (id: number, remark?: string) => {
    try {
      await agent.ElectricBox.delete(id, remark!);
      runInAction(() => {
        this.ElectricBoxRegistry.delete(id);
        this.totalRecord--;
        this.setOpenCloseDialog();
      });
    } catch (error) {
      console.log(error);
    }
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createElectricBox = async (ElectricBox: IElectricBox) => {
   
      await agent.ElectricBox.create(ElectricBox);
      runInAction(() => {
        this.loadElectricBox({ pageIndex: 0, pageSize: 5 });
        this.clearSelectedElectricBox();
      });
  
  };

  updateElectricBox = async (ElectricBox: IElectricBox) => {
  
      await agent.ElectricBox.update(ElectricBox);

      runInAction(() => {
        this.loadElectricBox({ pageIndex: 0, pageSize: 5 });
        this.ElectricBoxRegistry.delete(ElectricBox.electricBoxId!);
        this.ElectricBoxRegistry.set(ElectricBox.electricBoxId!, ElectricBox);
        this.clearSelectedElectricBox();
      });
  
  };

  loadElectricBoxDetail = async (id: number) => {
    try {
      const getElectricBoxDetail = await agent.ElectricBox.getDetail(id);
      runInAction(() => {
        this.selectedElectricBoxDetail = getElectricBoxDetail;
      });
    } catch (error) {}
  };
}
